module.exports = __webpack_public_path__ + "static/media/times-solid.22fd547d.svg";